import axios, { AxiosError, HttpStatusCode } from 'axios';
import { SEASON_FIGHTS_ERROR_MESSAGES } from '../../corelogic/domain/errors/gateway.errorMessages/seasonFights.error.messages';
import {
  SeasonFightsNotFoundError,
  SeasonFightsServerError,
} from '../../corelogic/domain/errors/seasonFights.error';
import { SeasonFights } from '../../corelogic/domain/models/seasonFights.model';
import { SeasonFightsGateway } from '../../corelogic/domain/ports/seasonFights.port';
import { getSecureRequestHeaders } from '../../corelogic/domain/utils/securityHeaders.utils';

// Unused to be removed soon
export class ApiSeasonFightsGateway implements SeasonFightsGateway {
  private apiEndpoint: string;

  private handleSeasonFightsError(error: AxiosError): never {
    if (axios.isAxiosError(error)) {
      switch (error.response?.status) {
        case HttpStatusCode.NotFound:
          throw new SeasonFightsNotFoundError(
            SEASON_FIGHTS_ERROR_MESSAGES.NOT_FOUND,
          );
        default:
          throw new SeasonFightsServerError(
            SEASON_FIGHTS_ERROR_MESSAGES.SERVER_ERROR,
          );
      }
    }
    throw new SeasonFightsServerError(
      SEASON_FIGHTS_ERROR_MESSAGES.SERVER_ERROR,
    );
  }

  constructor(apiEndpoint: string) {
    this.apiEndpoint = apiEndpoint;
  }

  async retrieveSeasonFights(
    startDate: Date,
    endDate: Date,
  ): Promise<SeasonFights[]> {
    // Convert Date objects to 'YYYY-MM-DD' strings
    const startDateString = startDate.toISOString().split('T')[0];
    const endDateString = endDate.toISOString().split('T')[0];

    try {
      const response = await axios.get<{
        seasonFights: SeasonFights[];
      }>(
        `${this.apiEndpoint}/season-fights?startDate=${startDateString}&endDate=${endDateString}`,
        {
          headers: {
            ...getSecureRequestHeaders(),
          },
        },
      );
      return response.data.seasonFights;
    } catch (error) {
      throw this.handleSeasonFightsError(error as AxiosError);
    }
  }
}
